import React from "react";
import CallToAction from "../components/CallToAction";
import Jumbotron from "../components/Jumbotron";
import SubNav from "../components/sub-nav";
import TeamLeaderItem from "../components/team-leader-item";
import TeamItem from "../components/team-item";
import { Element } from "react-scroll";
import PageWrapper from "../components/PageWrapper";
import styles from "../styles/team.module.scss";
import Helmet from "react-helmet";



const Team = ({ transition, data, location }) => {
	// const teamData = data.allMvruJson.edges[0].node.team;
	const pisList = data.pis.edges;
	const researchersList = data.researchers.edges;
	const adminList = data.admin.edges;
	const cta = data.cta.edges[0].node;
	const pageTitle = data.pageSettings.pageTitle;
	const metaDescription = data.pageSettings.metaDescription.metaDescription;
	const locale = data.pageSettings.node_locale;

	// const { leaders } = teamData.staff;


	const navList = [
		{
			label: locale === "th" ? "ผู้วิจัยหลัก" : "Principal Investigators",
			name: "leaders"
		},
		{
			label: locale === "th" ? "นักวิจัย/นักเทคนิค" : "Researcher/Technician",
			name: "researchers"
		},
		{
			label: locale === "th" ? "ฝ่ายบริหารจัดการ" : "Administrator",
			name: "admin"
		}
	];

	var itemsLeaders = pisList.map(({ node }, i) => {
		return (
			<TeamLeaderItem
				key={"leader-" + i}
				alt={!(i % 2)}
				slug={node.slug}
				locale={node.node_locale}
				photo={node.profilePicture.sizes.src}
				job_title={node.jobTitle}
				researchInterests={node.researchInterests}
				name={node.fullName}
				degree={node.academicDegree}
				bio={node.shortBio.content}
				email={node.email}
				pubMed={node.pubMedPublications}
				researchGate={node.researchGateUrl}
				mahidolProfile={node.mahidolProfileUrl}
				linkedInProfile={node.linkedInUrl}
			/>
		);
	});
	var smallItems = researchersList.map(({ node }, ixx) => {
		return (
			<TeamItem
				className={styles.small_item}
				key={"staff-" + ixx}
				alt={!(ixx % 2)}
				photo={node.profilePicture}
				job_title={node.jobTitle}
				name={node.fullName}
				degree={node.academicDegree}
				bio={node.shortBio.shortBio}
				email={node.email}
				pubMed={node.pubMedPublications}
				researchGate={node.researchGateUrl}
				mahidolProfile={node.mahidolProfileUrl}
				linkedInProfile={node.linkedInUrl}
			/>
		);
	});
	var adminItems = adminList.map(({ node }, ixx) => {
		return (
			<TeamItem
				className={styles.small_item}
				key={"staff-" + ixx}
				alt={!(ixx % 2)}
				photo={node.profilePicture}
				job_title={node.jobTitle}
				name={node.fullName}
				degree={node.academicDegree}
				bio={node.shortBio.shortBio}
				email={node.email}
				researchGate={node.researchGateUrl}
				mahidolProfile={node.mahidolProfileUrl}
				linkedInProfile={node.linkedInUrl}
			/>
		);
	});

	return (
		<PageWrapper
			locale={locale}
			location={location}
			data={data.layout.edges[0].node}
		>
			<main role="main" style={transition && transition.style}>
			<Helmet title={pageTitle  + " | Mahidol Vivax Research Unit"} />
				<Jumbotron
					className="mb-0"
					textAlign="text-center"
					contentAlign="justify-content-md-center"
				>
					<h1>{pageTitle}</h1>
					<p className={styles.jumbo_p}>
						{metaDescription}
					</p>
				</Jumbotron>

				<div className={"grey_bg "} style={{ position: "relative" }}>
					<div
						className="container"
						style={{ transform: "translateY(-50%)" }}
					>
						<div className="row justify-content-center">
							<div className="col-10 col-md-6 col-lg-10">
								<SubNav
									scroll={true}
									navList={navList}
									handleClick={() => {}}
								/>
							</div>
						</div>
					</div>

					<Element name="leaders" className="element mt-lg-0" style={{marginTop: "-2rem"}}>
						<div
							className={"container " + styles.no_padding}
							id="leaders"
						>
							{/* <div className={styles.wide_row} id="leaders">
								<h2>Team Leaders</h2>

								<div className="col-12">
									<div className="row justify-content-center">
										<div className="col-12">
											{itemsLeaders}
										</div>
									</div>
								</div>
							</div> */}

							<div className={styles.wide_row}>
								<div style={{ width: "100%" }}>
									<h2>{locale === "th" ? "ผู้วิจัยหลัก" : "Principal Investigators"}</h2>
								</div>
								{itemsLeaders}
							</div>
						</div>
					</Element>

					{/* <CallToAction
						className="my-5"
						leadText="Work with us"
						text="We are always looking for new team members. Check out our career opportunities."
						buttonLabel="Career opportunities"
						destination="/careers"
						arrow={true}
					/> */}
					<Element name="researchers" className="element">
						<div className={"container " + styles.no_padding}>
							<a id="second" />
							<div className={styles.wide_row}>
								<div style={{ width: "100%" }}>
									<h2>{locale === "th" ? "นักวิจัย/นักเทคนิค" : "Researcher / Technicians"}</h2>
								</div>
								{smallItems}
							</div>
						</div>
					</Element>
					<Element name="admin" className="element">
						<div className={"pb-2 container " + styles.no_padding}>
							<a id="second" />
							<div className={styles.wide_row}>
								<div style={{ width: "100%" }}>
									<h2>{locale === "th" ? "ฝ่ายบริหารจัดการ" : "Administrator"}</h2>
								</div>
								{adminItems}
							</div>
						</div>
					</Element>
				</div>

				<CallToAction
					className="my-5"
					leadText={cta.leadingText}
					text={cta.content.childMarkdownRemark.html}
					buttonLabel={cta.buttonLabel}
					destination={`/${locale}${
						cta.linkTo
					}`}
					arrow={true}
				/>
			</main>
		</PageWrapper>
	);
};

export default Team;

export const query = graphql`
	query TeamPageQuery($id: String!, $locale: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		pageSettings: contentfulTeamPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		pis: allContentfulPrincipalInvestigators(
			filter: { node_locale: { eq: $locale } }
			sort: { order: ASC, fields: [order] }
		) {
			edges {
				node {
					node_locale
					fullName
					researchInterests {
						title
						slug
					}
					jobTitle
					academicTitle
					slug
					academicDegree
					email
					profilePicture {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							srcWebp
							srcSetWebp
							sizes
						}
					}
					shortBio {
						content: childMarkdownRemark {
							html
						}
					}
					pubMedPublications
					linkedInUrl
					mahidolProfileUrl
					researchGateUrl
				}
			}
		}

		researchers: allContentfulResearchersTechnicians(
			filter: { node_locale: { eq: $locale } }
			sort: { order: ASC, fields: [fullName] }
		) {
			edges {
				node {
					fullName
					academicTitle
					jobTitle
					slug
					academicDegree
					email
					profilePicture {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							srcWebp
							srcSetWebp
							sizes
						}
					}
					shortBio {
						shortBio
					}
					pubMedPublications
					linkedInProfileUrl
					mahidolProfileUrl
					researchGateUrl
				}
			}
		}

		admin: allContentfulAdministrator(
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					fullName
					academicTitle
					slug
					jobTitle
					academicDegree
					email
					profilePicture {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							srcWebp
							srcSetWebp
							sizes
						}
					}
					shortBio {
						shortBio
					}
					linkedInUrl
					mahidolProfileUrl
					researchGateUrl
				}
			}
		}

		cta: allContentfulCallToAction(
			filter: {
				pageLocation: { eq: "team" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}

		allMvruJson {
			edges {
				node {
					team {
						page_title
						description
						sections
						staff {
							leaders {
								path
								photo
								job_title
								name
								degree
								bio
								phone
								email
								links {
									url
									label
								}
							}
							researchers {
								photo
								job_title
								name
								degree
								bio
								phone
								email
								links {
									url
									label
								}
							}
							administration {
								photo
								job_title
								name
								degree
								bio
								phone
								email
							}
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/team-template.js